import { useDataRequestFiltersContext, useMyDataRequestsApiContext } from '@vivli/core/infrastructure/context';

export const useDataRequestCounts = () => {
    const dataRequestFilters = useDataRequestFiltersContext();
    const { myDataRequests } = useMyDataRequestsApiContext();

    const draftCount = myDataRequests?.filter(dataRequestFilters.draftFilter)?.length || 0;

    const inProgressCount = myDataRequests?.filter(dataRequestFilters.activeFilter)?.length || 0;

    const fulfilledCount = myDataRequests?.filter(dataRequestFilters.fulfilledFilter)?.length || 0;

    const notApprovedCount = myDataRequests?.filter(dataRequestFilters.notApprovedFilter)?.length || 0;

    const archivedCount = myDataRequests?.filter(dataRequestFilters.archivedFilter)?.length || 0;

    return {
        draftCount,
        inProgressCount,
        fulfilledCount,
        notApprovedCount,
        archivedCount,
    };
};
